export default __webpack_public_path__ + "static/media/color-discover.bac01bec.svg";